import React, { useState, useEffect, useContext } from "react";
import Line, { DataType } from "charts/Line";
import { DataContext } from "App";

// 计算每个小时的占比
// let percent = [1];
// let max = 0,
//   part;
// for (let i = 0; i < 23; i++) {
//   [max] = percent.splice(
//     // eslint-disable-next-line no-loop-func
//     percent.findIndex(p => p === Math.max(...percent)),
//     1
//   );
//   part = Number((Math.random() * max).toFixed(4));
//   percent = percent.concat(part, max - part);
// }

function initData(
  yesterday: number = 0,
  today: number = 0,
  percent: number[] = Array(24).fill(0)
) {
  const pad = (s: string | number) => String(s).padStart(2, "0");

  return Array.from({ length: 48 }).map((e, i) => {
    const d = new Date(
      i < 24 ? new Date().getTime() - 24 * 60 * 60 * 1000 : new Date()
    );
    return {
      name: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(i % 24)}:00`,
      value: parseInt(String(percent[i % 24] * (i < 24 ? yesterday : today))),
    };
  });
}

// let x = 0;
function get24Data(total: DataType[]) {
  // const hours = (new Date().getHours() + x++) % 24;
  const hours = new Date().getHours();
  return total.slice(hours, hours + 24);
}

function getNextHours() {
  const d = new Date();
  const next =
    new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      d.getHours(),
      0,
      3
    ).getTime() + 3600000;

  return next - d.getTime();
}

const HourTrend: React.FC = () => {
  const appData = useContext(DataContext);
  const [totalData, setTotalData] = useState<DataType[]>([]);
  const [data, setData] = useState<DataType[]>([]);

  useEffect(() => {
    setTotalData(
      initData(
        appData?.total?.yesterday?.imp,
        appData?.total?.today?.imp,
        appData?.percent
      )
    );
  }, [appData]);

  useEffect(() => {
    let Timer: NodeJS.Timeout;

    function getData() {
      clearTimeout(Timer);
      setData(get24Data(totalData));
      Timer = setTimeout(() => {
        getData();
      }, Math.max(10000, getNextHours() || 10000));
    }

    getData();

    return () => clearTimeout(Timer);
  }, [totalData]);

  return <Line data={data} />;
};

export default HourTrend;
